export default __webpack_public_path__ + "static/media/Mycology.de69c279.pdf";